
export const makeDefaultChallengeParams = () => {
    return {
        permalink: "",
        lang: "en-US",
        sponsoredType: "Editorial"
    };
};

const initialState = {
    creatingChallenge: false,
    challengeParams: makeDefaultChallengeParams(),
    createChallengeFormSubmitted: false,
    createdChallengeId: null,
    error: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./public/pages/BreakCreator/initialState.js